/*
 * GridSearch — the ONE shared list-search box (CLAUDE.md §18.6 / §7.5).
 * Every list form's search row uses the same `.list-search-row` / `.list-search`
 * markup (theme/boStandard.css) — previously hand-copied into ~40 pages. This
 * component is the single source of that markup so a new form drops it in
 * instead of re-typing it, and any future tweak (icon, clear button, layout)
 * lands everywhere at once.
 *
 *  Usage:
 *    <GridSearch value={search} onChange={setSearch} />
 *    <GridSearch value={search} onChange={setSearch} placeholder="Search across all columns…" />
 *    <GridSearch value={search} onChange={setSearch} right={<span>3 of 10 matched</span>} />
 */
import type { ReactNode } from 'react';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Extra content on the same row, right of the search box (e.g. a match count). */
  right?: ReactNode;
}

export function GridSearch({ value, onChange, placeholder = 'Search…', right }: Props) {
  return (
    <div className="list-search-row">
      <div className="list-search">
        <i className="ti ti-search" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {value && (
          <span className="list-search-clear" onClick={() => onChange('')}>×</span>
        )}
      </div>
      {right}
    </div>
  );
}
